import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_da from "./translations/da/common.json";
import common_sv from "./translations/sv/common.json";

i18next.init({
    interpolation: { escapeValue: false },
    lng: document.getElementById('root').dataset.language,
    resources: {
        da: {
            common: common_da
        },
        sv: {
            common: common_sv
        },
    },
});

window.addEventListener('startReactForm', (e) => {
    let domRoot = document.getElementById('root')
    domRoot.classList.remove('hidden');

    if (domRoot.dataset.isLoaded !== "1") {
        domRoot.dataset.isLoaded = "1";
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <I18nextProvider i18n={i18next}>
                <App/>
            </I18nextProvider>
        );
    }

}, false);

